module.exports = __webpack_public_path__ + "img/headerlogo.f8317663.png";